import InputComponent from "../../components/input/input.component";
import Modal from "../../components/modal/modal.component";
import DatepickerComponent from "../../components/datepicker/datepicker.component";
import TextareaComponent from "../../components/textarea/textarea.component";
import { Controller, useForm } from "react-hook-form";
import { to } from "../../polyfill";
import { RegistersService } from "../../services/operation/registers";
import InvalidFeedback from "../../components/invalid-feedback/invalid-feedback.component";
import Button from "../../components/button/button.component";
import { useEffect, useMemo } from "react";
import { UtilsService } from "../../services/utils";

function AddPaymentModal({ data, show, setShow }: any) {
  const defaultValues = {
    _id: "",
    date: "",
    monto: "",
    concepto: "",
    receipt: ""
  };

  const {
    setValue,
    trigger,
    control,
    register,
    reset,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });

    const totalPaid = useMemo(() => {
      if(!data || !data.customer) return 0;
      const customer = data.customer;
  
      const paid = customer.pagos.reduce(( a: number, b: any) => a + b.monto, 0);
  
      return paid;
    }, [data]);
  
    const isPaid = useMemo(() => {
      if(!data || !data.customer) return 0;
      const customer = data.customer;
  
      const total = customer.valor_total;
  
      const paid = customer.pagos.reduce(( a: number, b: any) => a + b.monto, 0);
  
      return paid >= total 
    }, [data])

  const submit = async (payload: typeof defaultValues) => {
    const form = new FormData();
    form.append('_id', payload._id);
    form.append('date', payload.date);
    form.append('monto', payload.monto);
    form.append('concepto', payload.concepto);
    form.append('receipt', payload.receipt[0]);

    const [error, data] = await to(RegistersService.receipt(form));
    if (error) {
      alert(error.message);
    } else {
      setShow()
      reset(defaultValues);
    }
  };

  useEffect(() => {
    if(data && data.customer) {
      setValue('_id', data.customer._id);
    }
  }, [data])
  

  return (
    <Modal show={show}>
      <div className="modal-header">
        <h3 className="modal-title">Agregar pago a productor</h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        <div className="alert bg-light-warning border border-warning border-dashed d-flex flex-column flex-sm-row w-100 p-5 ">
          <i className="fa-solid fa-circle-exclamation fs-2hx text-warning me-4 mb-5 mb-sm-0"></i>
          <div className="d-flex flex-column">
            <h5 className="mb-1">Atención</h5>
            <span className="mb-3">
              El depósito que estas por registrar esta asociado a {data?.customer?.customer?.name}
              - {data?.customer?.field?.name} con la siguiente información:
            </span>
            <span className="fw-bold">Valor total: ${UtilsService.numberFormat(data?.customer?.valor_total)}</span>
            <span className="fw-bold">Fruta pagada: ${UtilsService.numberFormat(totalPaid)}</span>
            <span className="fw-bold">Adeudo: ${UtilsService.numberFormat(data?.customer?.valor_total - totalPaid)}</span>
          </div>
        </div>

        <div className="mb-5">
          <Controller
              name="date"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value},
                fieldState: { error },
              }) => (
                <>
                  <DatepickerComponent
                    label="Fecha de depósito *"
                    errors={error}
                    onChange={onChange}
                    value={value}
                  />
                  <InvalidFeedback error={error} />
                </>
              )}
            />
        </div>

        <div className="mb-5">
          <InputComponent
            label="Monto *"
            {...register("monto", { required: true, pattern: {
              value: /^\d+(\.\d{1,2})?$/,
              message:
                "Solo se permiten números y un máximo de dos decimales",
            }, })}
            errors={errors.monto}
          />
        </div>

        <div className="mb-5">
          <TextareaComponent
            label="Concepto *"
            {...register("concepto", { required: true })}
            errors={errors.concepto}
          />
        </div>

        <div className="mb-5">
          <InputComponent
            label="Comprobante *"
            type="file"
            {...register("receipt", { required: true })}
            onFileError={() => {
              setValue('receipt', '');
              trigger('receipt');
            }}
            errors={errors.receipt}
          />
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" type="button" onClick={setShow}>
          Cancelar
        </button>
        <Button
          className="btn btn-primary"
          disabled={!isValid}
          isLoading={isSubmitting}
          onClick={handleSubmit(submit)}
        >
          Guardar
        </Button>
      </div>
    </Modal>
  );
}

export default AddPaymentModal;
